export const CSmallTestimonialGridFragments = {
  field: `
    fragment smallTestimonialGrid on smallTestimonialGrid_MatrixField {
      ... on smallTestimonialGrid_block_Entry {
        id
        typeHandle
        idName
        showPlayVideoButtons
        testimonials {
          id
          title
          typeHandle
          uri
          ... on testimonials_Entry {
            testimonialOccupation
            testimonialAvatar {
              url @transform(mode: "crop", width: 88, height: 88, immediately: true)
              title
            }
            testimonialQuote
            testimonialImage {
              url @transform(mode: "crop", width: 530, height: 668, immediately: true)
              title
            }
            testimonialVideo {
              url
              title
              embeddedAsset {
                url
                title
              }
            }
          }
          ... on testimonialPages_Entry {
            testimonialOccupation
            testimonialAvatar {
              url @transform(mode: "crop", width: 44, height: 44, immediately: true)
              title
            }
            testimonialQuote
            testimonialImage {
              url @transform(mode: "crop", width: 530, height: 668, immediately: true)
              title
            }
            testimonialVideo {
              url
              title
              embeddedAsset {
                url
                title
              }
            }
          }
        }
      }
    }
  `,
}
